var React = require('react');

function ArrowDown2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5575 0.435547L5 3.87805L8.4425 0.435547L9.5 1.50055L5 6.00055L0.5 1.50055L1.5575 0.435547Z","fill":"currentColor"}));
}

ArrowDown2.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = ArrowDown2;

ArrowDown2.default = ArrowDown2;
